/** A bearer token is usable when it is a non-empty string with no whitespace or control characters (which would corrupt the header). It is not required to be a JWT. */
export function isUsableAccessToken(token: unknown): token is string {
    return typeof token === 'string' && token.length > 0 && !/[\s\u0000-\u001f\u007f]/.test(token);
}

/** An event source is a header value, so it has the same restrictions as a token. */
export function isUsableEventSource(eventSource: unknown): eventSource is string {
    return isUsableAccessToken(eventSource);
}

/** `URL.hostname` keeps the brackets on an IPv6 address. */
const _LOOPBACK_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]'];

/** True for `https:` URLs and for loopback hosts (local development); the token is never attached to anything else. */
export function isSecureRequestUrl(url: string): boolean {
    try {
        const _parsed = new URL(url, globalThis.location?.href);
        return _parsed.protocol === 'https:' || _LOOPBACK_HOSTNAMES.includes(_parsed.hostname);
    } catch {
        return false;
    }
}

/** A Jemma base URL is usable when it is non-empty, has no whitespace or control characters, and is HTTPS or loopback, so the token is never sent anywhere else. */
export function isUsableJemmaBaseUrl(baseUrl: unknown): baseUrl is string {
    return typeof baseUrl === 'string' && baseUrl.length > 0 && !/[\s\u0000-\u001f\u007f]/.test(baseUrl) && isSecureRequestUrl(baseUrl);
}